export const GET_REWARDS_VIEW = 'GET_REWARDS_VIEW'
export const UPDATE_REWARDS_VIEW = 'UPDATE_REWARDS_VIEW'
